<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'base-checkbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const isChecked = computed(() => {
      return props.modelValue
    })

    function onChange() {
      if (props.disabled) return

      emit('update:modelValue', !props.modelValue)
    }

    return {
      isChecked,
      onChange,
    }
  },
})
</script>

<template>
  <label
    class="flex items-start group"
    :class="[
      disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer',
    ]"
  >
    <div class="flex items-center h-5">
      <input
        type="checkbox"
        :name="name"
        :checked="isChecked"
        :disabled="disabled"
        class="sr-only"
        @change="onChange"
      >
      <div
        class="flex items-center justify-center size-6 border rounded transition-colors duration-150 ease-in-out"
        :class="[
          isChecked ? 'bg-primary border-primary' : 'bg-white border-gray-300 group-hover:border-primary',
          !disabled && 'group-focus-within:ring-2 group-focus-within:ring-primary group-focus-within:ring-offset-2'
        ]"
      >
        <svg
          v-if="isChecked"
          class="w-3 h-3 text-white fill-current"
          viewBox="0 0 20 20"
        >
          <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
        </svg>
      </div>
    </div>
    <div class="ml-3">
      <span class="font-medium text-gray-700">
        <slot>{{ label }}</slot>
      </span>
    </div>
  </label>
</template>
